module.exports = __webpack_public_path__ + "mainassets/img/faq-2-a.44dcf9d2.svg";